import {Model} from '@vuex-orm/core';

export class ExplanationFigure extends Model {
  static entity = 'explanation_figures';

  static primaryKey = ['questionId', 'figureId'];

  static fields() {
    return {
      questionId: this.attr(null),
      figureId: this.attr(null),
    };
  }

  questionId: string;
  figureId: string;
}
